import React, { Suspense } from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

const SettingsSideBar = React.lazy(() => import('./SettingsSideBar'))
const SettingsContentArea = React.lazy(() => import('./SettingsContentArea'))

const styleSheet = theme => ({
    settingsContainer: {
        display: 'flex',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: theme.palette.common.white,
    },
})

const style = injectJss(styleSheet)

// Purposely using process.env as opposed to getEnv helper function.
const shouldRender = WrappedComponent => props =>
    process.env.NODE_ENV == 'production' ? null : <WrappedComponent {...props} />

const Settings = ({ classes }) => (
    <Suspense fallback={<div>Loading...</div>}>
        <div className={classes.settingsContainer}>
            <SettingsSideBar />
            <SettingsContentArea />
        </div>
    </Suspense>
)

export default compose(
    shouldRender,
    style,
    pure
)(Settings)
